// recovery-bands-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{min} a %{max} dias": "%{min} a %{max} días",
    "%{min} dias ou mais": "%{min} días o más",
    "Abasteceram pouco antes da criação e entraram mesmo assim: a base do público é atualizada uma vez por dia, de madrugada.": "Cargaron poco antes de la creación y entraron igual: la base del público se actualiza una vez al día, de madrugada.",
    "Assim que o nível começa": "Apenas empieza el nivel",
    "Horário do envio": "Horario del envío",
    "Há quantos dias cada cliente estava sem abastecer quando entrou na campanha, e quantos voltaram em cada faixa.": "Cuántos días llevaba cada cliente sin cargar cuando entró en la campaña, y cuántos regresaron en cada rango.",
    "Incluído": "Incluido",
    "Limite de clientes": "Límite de clientes",
    "Menos de %{n} dias": "Menos de %{n} días",
    "Parte do público": "Parte del público",
    "Quem nunca abasteceu": "Quien nunca cargó",
    "Sem abastecer há": "Sin cargar hace",
    "Taxa de volta": "Tasa de regreso",
    "Teto de gasto": "Tope de gasto",
    "Volta por tempo sem abastecer": "Regreso por tiempo sin cargar",
    "Voltaram": "Regresaron",
};

export default catalogo;
